'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroContentNotAvailable = function NitroContentNotAvailable(_ref) {
  var animate = _ref.animate,
      animationDelay = _ref.animationDelay,
      animationDuration = _ref.animationDuration,
      backgroundIndex = _ref.backgroundIndex,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      description = _ref.description,
      imageHeight = _ref.imageHeight,
      imageMarginTop = _ref.imageMarginTop,
      imageWidth = _ref.imageWidth,
      minHeight = _ref.minHeight;
  return _react2.default.createElement(
    _styles.Wrapper,
    {
      className: className,
      minHeight: minHeight
    },
    _react2.default.createElement(
      _styles.Content,
      null,
      _react2.default.createElement(
        _styles.ContentAnimationWrap,
        {
          animate: animate,
          animationDelay: animationDelay,
          animationDuration: animationDuration
        },
        _react2.default.createElement(
          _styles.Heading,
          null,
          content
        ),
        _react2.default.createElement(
          _styles.Description,
          null,
          description
        ),
        children && _react2.default.createElement(
          _styles.Heading,
          null,
          children
        )
      ),
      _react2.default.createElement(_styles.Background, {
        animate: animate,
        animationDelay: animationDelay,
        animationDuration: animationDuration,
        background: backgroundIndex,
        imageHeight: imageHeight,
        imageMarginTop: imageMarginTop,
        imageWidth: imageWidth
      })
    )
  );
};

NitroContentNotAvailable.propTypes = {
  animate: _propTypes2.default.bool,
  animationDelay: _propTypes2.default.number,
  animationDuration: _propTypes2.default.number,
  backgroundIndex: _propTypes2.default.number,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  content: _propTypes2.default.string,
  description: _propTypes2.default.string,
  imageHeight: _propTypes2.default.string,
  imageMarginTop: _propTypes2.default.string,
  imageWidth: _propTypes2.default.string,
  minHeight: _propTypes2.default.string
};

NitroContentNotAvailable.defaultProps = {
  animationDelay: 0,
  animationDuration: 600,
  backgroundIndex: 0,
  content: 'Sorry, there is no data to display',
  imageHeight: '90px',
  imageMarginTop: '80px',
  imageWidth: '300px',
  minHeight: '90px'
};

exports.default = NitroContentNotAvailable;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-content-not-available/NitroContentNotAvailable.js
// module id = 2896
// module chunks = 4